import React from 'react'
import {components} from 'react-select'
import {Box, Flex, Text} from '@chakra-ui/react'
import PropTypes from 'prop-types'
import {CheckIcon} from '../../icons'
import {remCalc} from '../../../theme/_utils'

const Option = (props) => {
    const leftIcon = props.selectProps.leftIcon
    const optionLeftIcon = typeof leftIcon === 'function' ? leftIcon(props.data) : leftIcon

    return (
        <components.Option {...props}>
            <Flex justifyContent="space-between" alignItems="center" w="100%">
                <Flex flex="1" minW={0} alignItems="center" gap={2}>
                    {optionLeftIcon}
                    <Box minW={0}>{props.children || <Text>{props.label}</Text>}</Box>
                </Flex>
                {props.isSelected && <CheckIcon width={remCalc(10)} height={remCalc(10)} />}
            </Flex>
        </components.Option>
    )
}

Option.propTypes = {
    children: PropTypes.node,
    data: PropTypes.any,
    isSelected: PropTypes.bool,
    label: PropTypes.string,
    selectProps: PropTypes.object,
}

export default Option
